<template>
  <div id="video-overlay" @click.self="closeVideo">
    <div class="video-container">
      <div
        v-if="!isLoaded"
        class="video-loader"
        data-testid="video-loader"
      ></div>

      <button
        v-if="isLoaded"
        class="video-close-button"
        aria-label="Close video"
        @click="closeVideo"
      >
        <i class="far fa-times"></i>
      </button>
      <video
        v-show="isLoaded"
        ref="videoRef"
        data-testid="video-player"
        :controls="controls"
        preload="metadata"
        :style="style"
        class="video-player"
        autoplay
        @loadedmetadata="isLoaded = true"
        @loadeddata="$emit('loaded')"
      >
        <source :src="src" type="video/mp4" />
        {{ trans("media.videoNotSupported") }}
      </video>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const props = defineProps({
  src: { type: String, required: true },
  style: { type: Object, default: () => ({}) },
  controls: { type: Boolean, default: true },
});

const videoRef = ref<HTMLVideoElement | null>(null);
const isLoaded = ref(false);

const emit = defineEmits(["loaded", "close"]);

const closeVideo = () => {
  emit("close");
};
</script>
